import _ from "underscore";
import "Utils/underscoreMixins";

// Given a set of filters and a plan, return true if the plan should be
// shown. A filter set is a Map<Paths, Spec>. A Path is like
// "expected_costs.hospitalization", and describes the subject of the
// filter. A Spec is a Map<Type, Range>, where Type is one of "max",
// "min", "include", "exclude" or "ranges" . The Range is the set of values or the
// numeric comparison value.
export function filterPlan(filters, plan) {
  // Each key in the filter object restricts a specific key in the plan
  // object. All keys have to match in order for the plan to be shown.
  return _.every(filters, (spec, key) => {
    const plan_value = _.getPath(plan, key);
    // Each subkey in the filter object describes how it restricts the
    // corresponding key in the plan object, and all listed subkeys must
    // match.
    return _.every(spec, (filter_range, filter_type) => {
      if (!filter_range) {
        return true;
      }
      if (filter_range.length == 0) {
        return true;
      }
      if (filter_type == "max") {
        return plan_value <= filter_range;
      }
      if (filter_type == "min") {
        return filter_range <= plan_value;
      }
      if (filter_type == "include") {
        return filter_range.indexOf(plan_value) != -1;
      }
      if (filter_type == "exclude") {
        return filter_range.indexOf(plan_value) == -1;
        // Ranges is a list of min max objects.  Plans must fall into one of the listed ranges.
      }
      if (filter_type == "ranges") {
        return filter_range.some((range) => (range.max ? range.max >= plan_value : true) && (range.min ? range.min <= plan_value : true));
      }
    });
  });
}
